import React, { Component, Fragment } from 'react';

import { parseMediaUrl } from 'helpers/File';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import InputEmbedMedia from './InputEmbedMedia';
import InputEmbedMediaFilled from './InputEmbedMediaFilled';

import './EmbedMedia.scss';

export default class EmbedMedia extends Component {
  static propTypes = {
    mediaUrl: PropTypes.string,
    setMediaUrl: PropTypes.func,
    children: PropTypes.node,
    className: PropTypes.string,
    beforeSend: PropTypes.func
  };

  checkEmbedUrl = (embedUrl) => {
    if (embedUrl) {
      const videoObj = parseMediaUrl(embedUrl);

      if (videoObj.type === 'YOUTUBE') {
        this.props.setMediaUrl(`https://www.youtube.com/embed/${videoObj.id}`);
      } else if (videoObj.type === 'VIMEO') {
        this.props.setMediaUrl(`https://player.vimeo.com/video/${videoObj.id}`);
      } else {
        UiService.setAlertError('embed_invalid_url');
      }
    } else {
      UiService.setAlertError('embed_invalid_url');
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.mediaUrl && prevProps.mediaUrl !== this.props.mediaUrl) {
      this.checkEmbedUrl(this.props.mediaUrl);
    }
  }

  render() {
    const { mediaUrl, setMediaUrl, children, className, beforeSend } =
      this.props;

    return (
      <Fragment>
        {!mediaUrl && (
          <InputEmbedMedia
            setMediaUrl={setMediaUrl}
            checkEmbedUrl={this.checkEmbedUrl}
            mediaUrl={mediaUrl}
            className={className}
            beforeSend={beforeSend}
          >
            {children}
          </InputEmbedMedia>
        )}
        {mediaUrl && (
          <InputEmbedMediaFilled
            mediaUrl={mediaUrl}
            checkEmbedUrl={this.checkEmbedUrl}
            setMediaUrl={setMediaUrl}
          />
        )}
      </Fragment>
    );
  }
}
